import { render } from "./DownloadStatisticView.vue?vue&type=template&id=3d418e78&scoped=true"
import script from "./DownloadStatisticView.vue?vue&type=script&lang=js"
export * from "./DownloadStatisticView.vue?vue&type=script&lang=js"

import "./DownloadStatisticView.vue?vue&type=style&index=0&id=3d418e78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d418e78"]])

export default __exports__